import React, { useRef } from "react";

export const FileUploader = ({ handleFile, disableRequirement }) => {
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const files = Array.from(event.target.files || []);
    const allowExtension = /(\.png|\.jpg|\.jpeg|\.heic)$/i;

    const invalidFiles = files.filter(
      (file) => !allowExtension.exec(file?.name)
    );

    if (invalidFiles.length > 0) {
      alert("Please upload image files only (png, jpg, jpeg, heic)");
      return;
    }

    // Pass the array of valid image files
    handleFile(files);
  };

  return (
    <>
      <button
        className={`btn btn--viewai ${
          disableRequirement ? "btn--disabled" : ""
        }`}
        onClick={handleClick}
        disabled={disableRequirement}
      >
        Upload
      </button>

      <input
        type="file"
        multiple   // ENABLE MULTIPLE UPLOAD
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: "none" }}
      />
    </>
  );
};
